import type { IPrice } from './iPrice';
import Price from './price';

export type { IPrice };
export default Price;
